import { del, get, post, put } from "../axios";
import { responseIsSuccessful } from "../global-helpers";
import { ApiResponseStatus } from "../constants/enums";
import { generateArrayQueryParamsString } from "../helpers";
import { Contact } from "../models/Contact";
import { Place } from "../models/Place";
import { Phone } from "../models/Phone";
import { formatObjectWithNotes, simpleResponse } from "./api-helpers";

export function formatContactObject(contact) {
  formatObjectWithNotes(contact);
  if (contact.primary_place && contact.primary_place.length) {
    contact.primary_place = new Place(contact.primary_place[0]);
  } else {
    contact.primary_place = undefined;
  }

  if (contact.primary_phone && contact.primary_phone.length) {
    contact.primary_phone = new Phone(contact.primary_phone[0]);
  } else {
    contact.primary_phone = undefined;
  }
}

export async function getContacts(
  contactTypes = undefined,
  contactSubtypes = undefined
) {
  let queryString = generateArrayQueryParamsString(
    contactTypes,
    "contactTypes"
  );
  queryString = generateArrayQueryParamsString(
    contactSubtypes,
    "contactSubtypes",
    queryString
  );

  return await get(`contacts${queryString}`, window.localStorage.apiToken)
    .then(res => {
      let contactsAndCounts = {
        contacts: [],
        type_counts: {},
        subtype_counts: {}
      };
      if (responseIsSuccessful(res)) {
        if (res.data.contacts) {
          contactsAndCounts.contacts = res.data.contacts.map(c => {
            formatContactObject(c);
            return new Contact(c);
          });
        }
        if (res.data.type_counts) {
          contactsAndCounts.type_counts = res.data.type_counts;
        }
        if (res.data.subtype_counts) {
          contactsAndCounts.subtype_counts = res.data.subtype_counts;
        }
      }
      return contactsAndCounts;
    })
    .catch(err => {
      console.log(err);
      return { contacts: [], type_counts: {}, subtype_counts: {} };
    });
}

export async function getContact(contactId) {
  return await get(`contacts/${contactId}`, window.localStorage.apiToken)
    .then(res => {
      let contact = ApiResponseStatus.ERROR;
      if (responseIsSuccessful(res) && res.data.contact) {
        formatContactObject(res.data.contact);
        contact = new Contact(res.data.contact);
      }
      return contact;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export async function storeContact(contact) {
  return await post(
    "contacts",
    { contact_params: contact },
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res)) {
        return ApiResponseStatus.SUCCESS;
      }
      return ApiResponseStatus.ERROR;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export async function updateContact(contact) {
  return await put(
    `contacts/${contact.id}`,
    { contact_params: contact },
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res)) {
        return ApiResponseStatus.SUCCESS;
      }
      return ApiResponseStatus.ERROR;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export async function deleteContact(contact) {
  return simpleResponse(
    del(`contacts/${contact.id}`, window.localStorage.apiToken)
  );
}

export async function dissociateContactFromContract(contactId, contractId) {
  return simpleResponse(
    post(
      "contacts/dissociate-from-contract",
      {
        dissociation_params: {
          contact_id: contactId,
          contract_id: contractId
        }
      },
      window.localStorage.apiToken
    )
  );
}
